import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueResource from 'vue-resource';
import VueCookie from 'vue-cookie';

import VueRouter from 'vue-router';
import Header from './Components/Header.vue';
import Home from './Home/Home.vue';

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import "aos/dist/aos.css";

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import "./assets/css/style.scss";

import { routes } from './routes';
import { store } from './Store/store';

Vue.component('home', Home);
Vue.component('header-mx', Header);

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueCookie);

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    mode: 'history'
});

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')